import { devtools } from 'zustand/middleware';
import { create } from 'zustand';
import { type SearchState } from '@pkgs/components/hooks/stores/search/SearchStoreProvider';

import { isProductionClient } from '../../consts/environment';

type AutoCompleteStoreState = {
  inputText?: string;
  typedInText?: string;
  numberOfAutoCompleteOptions?: number;
  autoCompleteOptionIndex?: number;
  autoCompleteOptionCategory?: string;
  isMobileModalOpen: boolean;
  selectedLokaliseOptionIndex?: number;
  shouldShowSuggestions: boolean;
  aiDraftState?: SearchState;
};

type AutoCompleteStoreActions = {
  setInputText: (value: string | undefined) => void;
  setTypedInText: (value: string | undefined) => void;
  setNumberOfAutoCompleteOptions: (value: number | undefined) => void;
  setAutoCompleteOptionIndex: (value: number | undefined) => void;
  setAutoCompleteOptionCategory: (value: string | undefined) => void;
  setIsMobileModalOpen: (value: boolean) => void;
  setShouldShowSuggestions: (value: boolean) => void;
  setSelectedLokaliseOptionIndex: (value: number | undefined) => void;
  setAiDraftState?: (value: SearchState | undefined) => void;
  resetAiDraft?: () => void;
};

export const useAutoCompleteStore = create<AutoCompleteStoreState & AutoCompleteStoreActions>()(
  devtools(
    (set) => ({
      inputText: undefined,
      typedInText: undefined,
      numberOfAutoCompleteOptions: undefined,
      autoCompleteOptionIndex: undefined,
      autoCompleteOptionCategory: undefined,
      isMobileModalOpen: false,
      selectedLokaliseOptionIndex: undefined,
      shouldShowSuggestions: false,
      aiDraftState: undefined,
      setInputText: (value) => set({ inputText: value }, undefined, 'setInputText'),
      setTypedInText: (value) => set({ typedInText: value }, undefined, 'setTypedInText'),
      setNumberOfAutoCompleteOptions: (value) => set({ numberOfAutoCompleteOptions: value }, undefined, 'setNumberOfAutoCompleteOptions'),
      setAutoCompleteOptionIndex: (value) => set({ autoCompleteOptionIndex: value }, undefined, 'setAutoCompleteOptionIndex'),
      setAutoCompleteOptionCategory: (value) => set({ autoCompleteOptionCategory: value }, undefined, 'autoCompleteOptionCategory'),
      setIsMobileModalOpen: (value: boolean) =>
        set(
          {
            isMobileModalOpen: value,
            ...(!value && { aiDraftState: undefined }),
          },
          undefined,
          'setIsMobileModalOpen',
        ),
      setShouldShowSuggestions: (value) => set({ shouldShowSuggestions: value }, undefined, 'setShouldShowSuggestions'),
      setSelectedLokaliseOptionIndex: (value) => set({ selectedLokaliseOptionIndex: value }, undefined, 'setSelectedLokaliseOptionIndex'),
      setAiDraftState: (value) => set({ aiDraftState: value }, undefined, 'setAiDraftState'),
      resetAiDraft: () => set({ aiDraftState: undefined }, undefined, 'resetAiDraft'),
    }),
    {
      name: 'search-modules',
      store: 'auto-complete',
      enabled: !isProductionClient,
    },
  ),
);
